<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div class="card">    
    <div
      class="card-header d-flex align-items-center bg-primary font-weight-bold text-white"      
    >
      Jadwal Test Center
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <div class="card-body">
      <form @submit.prevent="postData">
        <div class="form-row">
                
            <div class="form-group col-md-12">
                <label for="level" class="font-weight-bold">Test Center</label>
                <multiselect
                    class="mulit-select"
                    label="namaTc"
                    placeholder="Pilih Nama TC"
                    :show-labels="false"
                    @select="updateSelect"
                    v-model="formData.dataTestCenter"
                    required
                    :options="namaTc"
                ></multiselect>
            <!-- <select class="form-control" name id>
                <option>Pilih Level</option>
                <option></option>
                <option></option>
            </select>-->
            </div>
            <div class="form-group col-md-12">
                <label for="tgl" class="font-weight-bold">Tanggal</label>
                <input
                    type="date"
                    class="form-control"
                    id="datePicker"
                    placeholder="Masukkan Nama Kupon"
                    v-model="formData.tanggalPelaksanaan"
                    required
                />
            </div>
            <div
            class="form-group col-md-12"
            v-for="(input,k) in formData.sesi_tc"
            :key="k"
            >
                <div class="form-row">
                    <div class="form-group col-md-4">
                    <label for="nama_dok" class="font-weight-bold">Sesi</label>
                    <input type="text" name="" class="form-control" id="" readonly v-model="input.sesi">
                    </div>
                    <div class="form-group col-md-4">
                    <label for="nama_dok" class="font-weight-bold">Waktu</label>
                    <input type="time" name="" class="form-control" id="" v-model="input.waktu">
                    </div>
            
                    <div class="col-1 d-flex align-items-center">
                    <div
                        class="btn btn-sm btn-success ml-2 mt-2"
                        @click="add_sesi(k)"
                        v-show="k == formData.sesi_tc.length-1"
                    >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </div>
                    <div
                        class="btn btn-sm btn-danger ml-2 mt-2"
                        @click="remove_sesi(k)"
                        v-show="k || ( !k && formData.sesi_tc.length > 1)"
                    >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </div>
                    </div>
                </div>
            
            </div>
            
            <div class="form-group col-md-12">
                <label for="kapasitas" class="font-weight-bold">Kapasitas</label>
                <input
                    type="number"
                    class="form-control"
                    id="kapasitas"
                    readonly
                    placeholder="Kapasitas"
                    v-model="formData.kapasitas"
                    required
                />
            </div>
            <div class="form-group col-md-6">
            <!-- <label for="sisa" class="font-weight-bold">Sisa</label> -->
                <input
                    type="hidden"
                    class="form-control"
                    :id="'sisa'"
                    placeholder="Terisi Otomatis"
                    disabled
                    v-model="formData.kapasitas"
                />
            </div>
        </div>
        <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3 float-right">
          <!-- <router-link to="/data-master/data-test-center">
            <Button class="btn btn-md btn-danger px-4 py-2 mr-3" type="button" color="danger">Tutup</Button>
          </router-link> -->
          <!-- <Button
            class="btn btn-md btn-success px-4 py-2"
            type="submit"

          >Simpan</Button> -->
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import MasterJadwalTcService from "../../../services/sertifikasi/jadwal-tc.service";
import DataTestCenterServices from "../../../services/datamaster/data-test-center.service";

export default {
  name: "Tambah Jadwal Test Center",
  data() {
    return {
      actionPost: "",
      namaTc : [],
      formData: {
          
        dataTestCenter: {
          idTc: ""
        },
        sesi_tc : [
            {
                id_sesi : "",
                sesi : "Sesi 1",
                waktu : ""
            } 
        ],
        kodeTc: "",
        sesiSatu: "",
        sesiDua: "",
        sesiTiga: "",
        sisa: "",
        tanggalPelaksanaan: "",
        status: ""
      },
    };
  },
  mounted() {
      this.getTestCenter()
  },
  methods: {
    getTestCenter() {
        var vm = this;
        DataTestCenterServices.getDataTestCenter("0",10000000,"default")
        .then(response => {
            vm.namaTc = response.data.data.content;
        })
        .catch(error => {
            // comment console console.log(error);
        });
    },
    add_sesi(index) { 
      var ke = index+2;
      var sesi = "Sesi "+ke
      this.formData.sesi_tc.push({
        id_sesi : "",
        sesi : sesi,
        waktu : ""
      });
      // comment console console.log(this.formData.sesi_tc);
    },

    remove_sesi(index) {
      this.formData.sesi_tc.splice(index, 1);
    },
   
    updateSelect(event) {
      var vm = this;
      this.formData.namaTc = event.namaTc;
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    postData() {
      // // comment console console.log("huuhuhhuhuhuhuh")
      // if (this.actionPost == "insert") {
        this.insertData(this.formData);
      // } else if (this.actionPost == "update") {
      //   this.putData();
      // }
    },

    insertData(formData) {
        let loader = this.$loading.show({
            container: false ? null : this.$refs.formContainer,
            canCancel: true,
            onCancel: this.onCancel
        });
        this.formData.tanggalPelaksanaan =
        this.formData.tanggalPelaksanaan + " 12:00:00";
        // comment console console.log(formData);
        // comment console console.log("post");
        var vm = this;
        MasterJadwalTcService.postJadwalTc(formData)
        .then(response => {
            loader.hide();
            vm.alertSuccess();
        })
        .catch(error => {
            // comment console console.log(error);
            vm.alertError();
        });
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>
